module.exports = __webpack_public_path__ + "static/media/CircularStd-MediumItalic.f31aaf0e.ttf";